<template>
  <div class="table-section-v2">
    <div class="table-card-v2">
      <div class="table-header-v2">
        <div class="table-title-v2">
          <i class="fa fa-table"></i>
          Деталі
        </div>
        <button class="btn-v2 btn-outline-v2 btn-sm-v2" @click="showHotkeysHelp"
          :v-b-tooltip.hover.top="hotkeysTooltip">
          <i class="fa fa-keyboard"></i>
          {{ hotkeysButtonText }}
        </button>
      </div>
      <div class="table-content-v2">
        <form id="detailTableForm" class="table-wrapper">
          <table id="main_table" class="main_table table table-bordered">
            <thead>
              <tr>
                <th rowspan="2" style="min-width: 25px !important;">№</th>
                <th rowspan="2" style="min-width:80px !important;">Опції</th>
                <th :colspan="showEdgeSidesCount ? 2 : 1" style="min-width:62px !important;">Довжина</th>
                <th :colspan="showEdgeSidesCount ? 2 : 1" style="min-width:62px !important;">Ширина</th>
                <th rowspan="2" style="min-width:40px !important;">К-ть</th>
                <th rowspan="2" style="min-width:30px !important;" v-b-tooltip.hover.right="'Обертати'">
                  <span>
                    <i class="fa fa-sync"></i>
                    <br>
                    <i class="fa fa-xs fa-question-circle"></i>
                  </span>
                  <div class="checkbox-container">
                    <input type="checkbox" id="rotate_all" @change="rotateAll" class="checkbox-input">
                    <label for="rotate_all"></label>
                  </div>
                </th>
                <th colspan="4" style="min-width:720px !important;max-width:720px !important;">Кромка</th>
                <th rowspan="2" style="min-width:242px !important;">Матеріал</th>
                <th colspan="3" style="min-width:91px !important;">Стяжка</th>
                <th rowspan="2" style="min-width:82px !important;">
                  <span>Порізка за <br> текстурою</span>
                </th>
                <th rowspan="2" style="min-width:120px !important;">Шаблон</th>
                <th rowspan="2" style="min-width:110px !important;">Виріб</th>
                <th rowspan="2" style="min-width:110px !important;">Деталь</th>
              </tr>
              <tr>
                <th style="min-width:70px !important;">мм</th>
                <th v-if="showEdgeSidesCount" style="min-width:37px !important;"
                  v-b-tooltip.hover.right="'Кількість сторін, що обклеюються, за довжиною'">
                  К <i class="fa fa-xs fa-question-circle"></i>
                </th>

                <th style="min-width:70px !important;">мм</th>
                <th v-if="showEdgeSidesCount" style="min-width:37px !important;"
                  v-b-tooltip.hover.right="'Кількість сторін, що обклеюються, за шириною'">
                  К <i class="fa fa-xs fa-question-circle"></i>
                </th>

                <th style="min-width: 180px !important;max-width: 180px !important;">Верх</th>
                <th style="min-width: 180px !important;max-width: 180px !important;">Низ</th>
                <th style="min-width: 180px !important;max-width: 180px !important;">Ліворуч</th>
                <th style="min-width: 180px !important;max-width: 180px !important;">Праворуч</th>

                <th style="min-width: 62px !important;"
                  v-b-tooltip.hover.right="'0 - Відсутня, 1-Звичайна, >1-Економ (Обов\'язковий вибір Базової деталі \'БД\')'">
                  <span>Тип <i class="fa fa-xs fa-question-circle"></i></span>
                </th>
                <th colspan="2" style="min-width: 41px !important;"
                  v-b-tooltip.hover.right="'Базова деталь для Економ стяжки'">
                  БД <i class="fa fa-xs fa-question-circle"></i>
                </th>
              </tr>
            </thead>
            <tbody style="min-height:150px">
              <tr v-for="(detail, index) in details" :data-key="index" :key="index"
                :class="index === activeIndex ? 'active' : ''" @keyup="visual(index)" @mousedown="visual(index)">
                <td style="min-width: 25px !important;">{{ index + 1 }}</td>
                <td style="min-width: 80px !important;">
                  <div class="btn-group">
                    <b-button size="sm" v-b-tooltip.hover.right="'Копіювати'" @click="copyDetail(index)"
                      variant="outline-info"><i class="far fa-copy"></i></b-button>
                    <b-button size="sm" variant="outline-danger" v-b-tooltip.hover.right="'Видалити'"
                      @click="removeDetail(index)">
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                  </div>
                </td>

                <td style="min-width: 70px !important;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'L_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'L_', detail)">
                  <input type="text" required step="0.1" min="20" max="9999.9" lang="en-150" @keyup="onlyNumeric"
                    @keydown="handleNavigation" @click="ifSelect($event)" @change="fixedLength(detail, 'length')"
                    v-model.number="detail.length" />
                </td>
                <td v-if="showEdgeSidesCount" style="min-width: 37px !important;">
                  <input type="text" step="1" required min="0" max="2" v-model.number="detail.k1"
                    @change="addEdge($event.target, index, 1, detail)" @keydown="handleNavigation"
                    @click="ifSelect($event)" class="sm-one" />
                </td>
                <td style="min-width: 70px !important;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'W_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'W_', detail)">
                  <input type="text" required step="0.1" min="20" max="9999.9" lang="en-150"
                    @change="fixedLength(detail, 'width')" @keyup="onlyNumeric" @keydown="handleNavigation"
                    @click="ifSelect($event)" v-model.number="detail.width" />
                </td>
                <td v-if="showEdgeSidesCount" style="min-width: 37px !important;">
                  <input type="text" required step="1" min="0" max="2" v-model.number="detail.k2"
                    @change="addEdge($event.target, index, 2, detail)" @keydown="handleNavigation"
                    @click="ifSelect($event)" class="sm-one" />
                </td>
                <td style="min-width: 40px !important;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'Qt_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'Qt_', detail)">
                  <input required type="text" @keyup="onlyNumeric" step="1" min="1" lang="en-150"
                    @keydown="handleNavigation" @click="ifSelect($event)" v-model.number="detail.count"
                    class="one-qt" />
                </td>
                <td style="min-width: 30px !important;position: relative;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'Rotate_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'Rotate_', detail)">
                  <div class="checkbox-container">
                    <input type="checkbox" :id="'Rotate_' + index" class="checkbox-input" v-model.number="detail.rotate"
                      @keydown="handleNavigation" @change="checkboxChange($event.target.checked, 'rotate')">
                    <label :for="'Rotate_' + index"></label>
                  </div>
                </td>

                <td style="min-width: 180px !important;max-width: 180px !important;"
                  :class="{ 'validation-error tooltiper red': detailValidation(detail.No, 'EdgeT_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeT_', detail)">
                  <select class="custom-select material" v-model="detail.edge_t"
                    :style="getEdgeSelectStyle(detail.edge_t)" @change="procesK(detail)"
                    @keydown="handleSelectNavigation($event, edges, 'edge_t')">
                    <option :value="null">Ні</option>
                    <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                      {{ (i + 1) + ' ' }} {{ edge.full_name }}
                    </option>
                  </select>
                </td>
                <td style="min-width: 180px !important;max-width: 180px !important;"
                  :class="{ 'validation-error tooltiper red': detailValidation(detail.No, 'EdgeB_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeB_', detail)">
                  <select v-model="detail.edge_b" :style="getEdgeSelectStyle(detail.edge_b)"
                    class="custom-select material" @change="procesK(detail)"
                    @keydown="handleSelectNavigation($event, edges, 'edge_b')">
                    <option :value="null">Ні</option>
                    <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                      {{ (i + 1) + ' ' }} {{ edge.full_name }}
                    </option>
                  </select>
                </td>
                <td style="min-width: 180px !important;max-width: 180px !important;"
                  :class="{ 'validation-error tooltiper red': detailValidation(detail.No, 'EdgeL_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeL_', detail)">
                  <select v-model="detail.edge_l" :style="getEdgeSelectStyle(detail.edge_l)"
                    class="custom-select material" @change="procesK(detail)"
                    @keydown="handleSelectNavigation($event, edges, 'edge_l')">
                    <option :value="null">Ні</option>
                    <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                      {{ (i + 1) + ' ' }} {{ edge.full_name }}
                    </option>
                  </select>
                </td>
                <td style="min-width: 180px !important;max-width: 180px !important;"
                  :class="{ 'validation-error tooltiper red': detailValidation(detail.No, 'EdgeR_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'EdgeR_', detail)">
                  <select v-model="detail.edge_r" :style="getEdgeSelectStyle(detail.edge_r)"
                    class="custom-select material" @change="procesK(detail)"
                    @keydown="handleSelectNavigation($event, edges, 'edge_r')">
                    <option :value="null">Ні</option>
                    <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
                      {{ (i + 1) + ' ' }} {{ edge.full_name }}
                    </option>
                  </select>
                </td>

                <td style="min-width: 242px !important;max-width: 242px !important;">
                  <select v-model="detail.material" :style="getMaterialSelectStyle(detail.material)"
                    class="custom-select material" required
                    v-b-tooltip.hover.top="materials.find(edge => edge.ref === detail.material)?.full_name ?? ''"
                    @keydown="handleSelectNavigation($event, materials, 'material')"
                    @change="updateMaterial(index, $event.target.value)">
                    <option value="" disabled>Виберіть*</option>
                    <option v-for="(material, i) in materials" :value="material.ref" :key="i">
                      {{ (i + 1) + ' ' }} {{ material.full_name }}
                    </option>
                  </select>
                </td>

                <td style="min-width: 62px !important;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'Screed_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'Screed_', detail)">
                  <select class="custom-select one" v-model.number="detail.screed"
                    @keydown="handleSelectNavigation($event, screeds, 'screed')">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option v-for="(screed, i) in screeds" :value="screed.No" :key="i">{{ screed.No }}
                    </option>
                  </select>
                </td>
                <td style="min-width: 41px !important;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'ScreedBP_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'ScreedBP_', detail)">
                  <div class="checkbox-container">
                    <input type="checkbox" :id="'ScreedBP_' + index" class="checkbox-input"
                      v-model.number="detail.screed_bp" @keydown="handleNavigation"
                      @change="checkboxChange($event.target.checked, 'screed_bp')">
                    <label :for="'ScreedBP_' + index"></label>
                  </div>
                </td>

                <td style="min-width: 82px !important;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'CutToTxtrs_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'CutToTxtrs_', detail)">
                  <div class="checkbox-container">
                    <input type="checkbox" :id="'CutToTxtrs_' + index" class="checkbox-input"
                      v-model.number="detail.cut_to_txtrs" @keydown="handleNavigation"
                      @change="checkboxChange($event.target.checked, 'cut_to_txtrs')">
                    <label :for="'CutToTxtrs_' + index"></label>
                  </div>
                </td>
                <td style="min-width: 120px !important;"
                  :class="{ 'validation-error tooltiper': detailValidation(detail.No, 'Template_') }"
                  v-b-tooltip.hover.right="detailValidationText(detail.No, 'Template_', detail)">
                  <select required v-model.number="detail.template" @change="pClear(index)"
                    @keydown="handleSelectNavigation($event, null, 'template')">
                    <option value="1">Відсутній</option>
                    <option value="2">Косі різи</option>
                    <option value="3">Фрезерування по дузі</option>
                    <option value="4">Вибірка чверті</option>
                    <option value="5">Паз під ДВП</option>
                    <option value="6">Нестандартне фрезерування</option>
                    <option value="7">Різ під нахилом пили</option>
                    <option value="8">Фрезерування під петлі</option>
                    <option value="9">Виріз для фасаду без ручок</option>

                  </select>
                </td>
                <td style="min-width: 110px !important;">
                  <select class="custom-select" v-if="detailsName.length > 0" v-model="detail.name"
                    @keydown="handleSelectNavigation($event, detailsName, 'name')">
                    <option value="">Ні</option>

                    <option v-for="(option, j) in detailsName" v-if="option.name.length > 0" :value="option.name"
                      :key="j">
                      {{ option.name }}
                    </option>
                  </select>
                </td>
                <td style="min-width: 110px !important;">
                  <span>
                    <input class="one" placeholder="Деталь" type="text" @keydown="handleNavigation"
                      @click="ifSelect($event)" v-model="detail.detail_name" />
                  </span>
                </td>

              </tr>
            </tbody>
          </table>
        </form>

        <div class="table-actions-v2">
          <button class="btn-v2 btn-primary-v2 btn-compact" type="button" v-hotkey="keymap"
            :disabled="materials.length == 0" id="addNewDetail" @click="addNewDetail">
            <i class="fa fa-plus"></i>
            Додати (Alt +)
          </button>
          <button class="btn-v2 btn-outline-v2 btn-compact" type="button" :disabled="materials.length == 0"
            @click="exportData">
            <i class="fa fa-download"></i>
            Експорт даних
          </button>
          <button class="btn-v2 btn-outline-v2 btn-compact" type="button" @click="fileUploadEvent">
            <i class="fa fa-upload"></i>
            Імпорт даних
          </button>
        </div>
      </div>
    </div>

    <input style="display: none" ref="fileImport" type="file" @change="handleFileUpload" accept=".xls, .xlsx" />

    <!-- Модальное окно с горячими клавишами -->
    <b-modal id="hotkeys-modal" size="lg" :title="hotkeysModalTitle" ok-only>
      <div class="row">
        <div class="col-md-6">
          <h6>Основна навігація</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>↑</kbd></td>
                <td>Перехід до ячейки вище</td>
              </tr>
              <tr>
                <td><kbd>↓</kbd></td>
                <td>Перехід до ячейки нижче</td>
              </tr>
              <tr>
                <td><kbd>←</kbd></td>
                <td>Перехід до ячейки зліва</td>
              </tr>
              <tr>
                <td><kbd>→</kbd></td>
                <td>Перехід до ячейки справа</td>
              </tr>
              <tr>
                <td><kbd>Enter</kbd></td>
                <td>Перехід до наступної ячейки (як стрілка вправо)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          <h6>Швидкий вибір в селектах</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>0</kbd></td>
                <td>Вибір "Ні" (для кромок)</td>
              </tr>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>1-9</kbd></td>
                <td>Вибір опції за номером</td>
              </tr>
              <tr v-if="!isMac">
                <td><kbd>Ctrl</kbd> + <kbd>цифра</kbd></td>
                <td>Альтернативний спосіб</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <h6>Чекбокси</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>Space</kbd></td>
                <td>Перемикання чекбокса</td>
              </tr>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>0/1</kbd></td>
                <td>Вимкнути/увімкнути</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          <h6>Інші</h6>
          <table class="table table-sm">
            <tbody>
              <tr>
                <td><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>+</kbd></td>
                <td>Додати нову деталь</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="alert alert-info mt-3">
        <small>
          <i class="fas fa-info-circle mr-1"></i>
          <strong>Особливості:</strong> Автоматичне створення нових рядків, пропуск недоступних елементів,
          оновлення 2D візуалізації при переході між рядками.
          <br>
          <strong>Примітка:</strong> {{ noteText }}
        </small>
      </div>
    </b-modal>
  </div>
</template>

<script>
import $ from 'jquery';
import DetailModal from "@/components/modals/detailModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      groups: app.groups,
      activeIndex: 0,
      rotateAllValue: 0,
      base_template: 1,
      // Добавляем переменные для навигации по таблице
      currentRow: 0,
      currentCol: 0,
      tableNavigationEnabled: true,
      requiredHeaders: [
        "Довжина",
        "Ширина",
        "Кількість",
        "Обертати",
        "Верх",
        "Низ",
        "Ліворуч",
        "Праворуч",
        "Матеріал",
        "Стяжка",
        "Стяжка БД",
        "Порізка за текстурою",
        "Виріб",
        "Деталь",
      ],
      json_fields: [[
        'Довжина',
        'Ширина',
        'Кількість',
        'Обертати',
        'Верх',
        'Низ',
        'Ліворуч',
        'Праворуч',
        'Матеріал',
        'Стяжка',
        'Стяжка БД',
        'Порізка за текстурою',
        'Виріб',
        'Деталь',
      ]]
    }
  },
  computed: {
    keymap() {
      return {
        'alt++': this.addDetailHotKey,
        'alt+=': this.addDetailHotKey,
      }
    },
    showEdgeSidesCount() {
      return this.$store.state.auth.settings?.show_edge_sides_count || false;
    },
    order() {
      return this.$store.state.data.order
    },
    details: {
      get: function () {
        return this.$store.state.data.details
      },
      set: function (newValue) {
        this.$store.commit('data/SET_DETAILS', newValue)
      }

    },
    materials() {
      return this.$store.state.data.materials;
    },
    edges() {
      return this.$store.state.data.edges;
    },
    detailsName() {
      return this.$store.state.data.detailsNames;
    },
    resp() {
      return this.$store.state.data.response;
    },
    detail() {
      return this.$store.state.data.detail;
    },
    screeds() {
      return this.$store.state.data.screeds;
    },

    // Определяем операционную систему
    isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    },

    // Текст кнопки в зависимости от ОС
    hotkeysButtonText() {
      return 'Гарячі клавіші';
    },

    // Подсказка в зависимости от ОС
    hotkeysTooltip() {
      return this.isMac
        ? 'Гарячі клавіші для навігації (Ctrl + цифра для швидкого вибору)'
        : 'Гарячі клавіші для навігації (Alt + цифра для швидкого вибору)';
    },

    // Заголовок модального окна в зависимости от ОС
    hotkeysModalTitle() {
      return this.isMac
        ? 'Гарячі клавіші для навігації (Mac)'
        : 'Гарячі клавіші для навігації (Windows/Linux)';
    },
    noteText() {
      return this.isMac
        ? 'На Mac використовуйте Ctrl замість Alt для уникнення конфліктів з браузером.'
        : 'На Windows / Linux використовуйте Alt для швидкого вибору.';
    }
  },
  methods: {
    procesK(detail) {
      detail.k1 = (detail.edge_b != null) + (detail.edge_t != null);
      detail.k2 = (detail.edge_r != null) + (detail.edge_l != null);
    },
    fileUploadEvent() {
      this.$refs.fileImport.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });

        // Беремо перший лист
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Конвертуємо лист у формат JSON
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (jsonData.length) {
          const fileHeaders = jsonData[0]; // Перший рядок як заголовки

          // Перевірка заголовків
          const isValid = this.requiredHeaders.every((header) =>
            fileHeaders.includes(header)
          );

          if (!isValid) {
            this.$toast.error("Завантажений файл має неправильні колонки");
            return;
          }

          const data = jsonData.slice(1);

          this.details = data.map((item) => {
            return {
              length: item[0],
              width: item[1],
              count: item[2],
              rotate: item[3] ?? 0,
              edge_t: this.edges[item[4] - 1]?.ref ?? null,
              edge_b: this.edges[item[5] - 1]?.ref ?? null,
              edge_l: this.edges[item[6] - 1]?.ref ?? null,
              edge_r: this.edges[item[7] - 1]?.ref ?? null,
              material: this.materials[item[8] - 1]?.ref ?? null,
              screed: this.screeds.find(screed => screed.No == item[9]) != undefined || item[9] == 1 ? item[9] : 0,
              screed_bp: item[10] ?? 0,
              cut_to_txtrs: item[11] ?? 0,
              name: this.detailsName[item[12] - 1]?.name ?? '',
              detail_name: item[13],
              template: 1,
              "No": this.details.length > 0 ? this.details[this.details.length - 1]['No'] + 1 : 1,
              "k1": 0,
              "k2": 0,
              "note": '',
              "p1": 0,
              "p2": 0,
              "p3": 0,
              "p4": 0,
              "edge_template": null,
              "file": '',
            };
          })

          this.details.forEach(detail => this.procesK(detail));
          this.$nextTick(() => {
            this.visual(0);
          })
        } else {
          this.$toast.error("Файл порожній або має неправильний формат.");
        }
        this.$refs.fileImport.value = ''

      };

      reader.readAsBinaryString(file);
    },
    exportData() {
      let data = this.details.map((detail) => {
        let edgeT = this.edges.findIndex(item => item.ref === detail.edge_t),
          edgeB = this.edges.findIndex(item => item.ref === detail.edge_b),
          edgeL = this.edges.findIndex(item => item.ref === detail.edge_l),
          edgeR = this.edges.findIndex(item => item.ref === detail.edge_r),
          name = this.detailsName.findIndex(item => item.name === detail.name),
          material = this.materials.findIndex(item => item.ref === detail.material);


        return [
          detail.length,
          detail.width,
          detail.count,
          detail.rotate,
          edgeT === -1 ? '' : (edgeT + 1),
          edgeB === -1 ? '' : (edgeB + 1),
          edgeL === -1 ? '' : (edgeL + 1),
          edgeR === -1 ? '' : (edgeR + 1),
          material === -1 ? '' : (material + 1),
          detail.screed,
          detail.screed_bp,
          detail.cut_to_txtrs,
          name == -1 ? '' : (name + 1),
          detail.detail_name,
        ]
      })
      // Перетворюємо дані в аркуш
      const worksheet = XLSX.utils.aoa_to_sheet([...this.json_fields, ...data]);

      // Створюємо книгу
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Лист1");

      // Генеруємо файл Excel
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      // Зберігаємо файл
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream"
      });
      saveAs(blob, "example.xlsx");
    },
    addDetailHotKey() {
      if (this.materials.length !== 0) {
        this.addNewDetail()
      }
    },
    fixedLength(detail, key) {
      detail[key] = detail[key].toString().replace(/[^0-9\.\,]+/g, '') == '' ? '' : parseFloat(detail[key]).toFixed(1)
    },
    detailValidation(i, p) {
      if (this.resp?.Parts) {
        let item = this.resp.Parts.find(part => part.No == i);
        let response = '';

        if (item) {
          if (item[p] !== undefined) {
            return true;
          }

          if (p === 'Template_') {
            const hasExtendedDetails = ['P1_', 'P2_', 'P3_', 'P4_', 'EdgeA1_'].some(key => item[key] !== undefined);
            if (hasExtendedDetails) {
              return true;
            }
          }

          if (item[p] === 0) {
            if (p.includes('Edge')) {
              return true;
            } else if (p.includes('rotate') || p.includes('screed_bp')) {
              return true;
            }
          }
        }

        return false;
      }

      return false;
    },
    detailValidationText(i, p, detail) {
      if (this.resp?.Parts) {
        let item = this.resp.Parts.find(part => part.No == i);
        let response = '';

        if (item) {
          if (item[p] !== undefined) {
            response = `Вірно: ${item[p]}`;
          }

          if (p === 'Template_') {
            const hasExtendedDetails = ['P1_', 'P2_', 'P3_', 'P4_', 'EdgeA1_'].some(key => item[key] !== undefined);
            if (hasExtendedDetails) {
              response = 'Помилка у розширеному деталюванні';
            }
          }

          if (item[p] === 0) {
            if (p.includes('Edge')) {
              response = 'Вірно: Ні';
            } else if (p.includes('rotate') || p.includes('screed_bp')) {
              response = 'Вірно: Викл(0)';
            }
          }
        }

        return response;
      }

      const edgeMap = {
        'EdgeT_': detail.edge_t,
        'EdgeB_': detail.edge_b,
        'EdgeL_': detail.edge_l,
        'EdgeR_': detail.edge_r
      };

      if (p in edgeMap) {
        return this.edges.find(edge => edge.ref === edgeMap[p])?.full_name ?? '';
      }

      return '';
    },
    rotateAll() {
      this.rotateAllValue = this.rotateAllValue == 1 ? 0 : 1;
      this.details.forEach((item) => item.rotate = this.rotateAllValue)
    },
    addEdge(target, i, t) {
      let value = target.value.trim();
      if (value === '') value = '0';

      value = value.replace(/[^0-9.,]+/g, '').replace(/^0+(?=\d)/, '');

      const max = $(target).attr('max');
      if (max !== undefined && parseFloat(value) > parseFloat(max)) {
        value = max;
      }

      let v = parseInt(value);
      if (isNaN(v) || v < 0) v = 0;
      if (v > 2) v = 2;


      const defEdge = this.$store.getters['data/defaultEdge'];
      if (!this.edges.length || defEdge === undefined) return;

      const edgeRef = defEdge.ref;

      if (t === 1) {
        this.details[i].edge_t = v > 0 ? edgeRef : null;
        this.details[i].edge_b = v === 2 ? edgeRef : null;
        this.details[i].k1 = v;

      }

      if (t === 2) {
        this.details[i].edge_l = v > 0 ? edgeRef : null;
        this.details[i].edge_r = v === 2 ? edgeRef : null;
        this.details[i].k2 = v;
      }

    },
    ifSelect(e) {
      if (typeof e.target.select == 'function') {
        e.target.select();
      }
    },
    onlyNumeric(e) {
      if (e.target.value == '') {
        return;
      }
      e.target.value = e.target.value.replace(/^0+(?=\d)/, '')
      let max = $(e.target).attr('max');
      if (e.key != '.' && e.key != ',') {
        e.target.value = e.target.value.replace(/[^0-9\.\,]+/g, '')
      }

      if (max != undefined && max < e.target.value) {
        e.target.value = max
      }

    },
    // Методы навигации по таблице
    handleTableNavigation(e) {
      if (!this.tableNavigationEnabled) return;

      const key = e.key;
      const activeElement = document.activeElement;

      // Проверяем, что активный элемент находится в таблице
      if (!activeElement || !activeElement.closest('#main_table')) return;

      // Фокус будет управляться через CSS

      // Получаем текущую позицию в таблице
      const currentCell = activeElement.closest('td');
      if (!currentCell) return;

      const currentRow = currentCell.closest('tr');
      const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
      const colIndex = Array.from(currentRow.children).indexOf(currentCell);

      let nextRow = rowIndex;
      let nextCol = colIndex;

      switch (key) {
        case 'ArrowUp':
          e.preventDefault();
          if (rowIndex > 0) {
            nextRow = rowIndex - 1;
          } else {
            // Если это первая строка, остаемся на месте
            nextRow = 0;
          }
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (rowIndex < this.details.length - 1) {
            nextRow = rowIndex + 1;
          } else {
            // Если это последняя строка, создаем новую
            this.addNewDetail();
            nextRow = this.details.length - 1;
            nextCol = 2;
            // Ждем обновления DOM перед поиском элемента
            this.$nextTick(() => {
              this.focusOnElement(nextRow, nextCol, currentRow, key);
            });
            return;
          }
          break;
        case 'ArrowLeft':
          e.preventDefault();
          if (colIndex <= 0) {
            // Если мы в первой ячейке строки, переходим к предыдущей строке
            if (rowIndex > 0) {
              nextRow = rowIndex - 1;
              nextCol = currentRow.children.length - 1; // Последняя ячейка предыдущей строки
            } else {
              // Если это первая строка, остаемся на месте
              nextCol = 0;
            }
          } else {
            nextCol = colIndex - 1;
          }
          break;
        case 'ArrowRight':
          e.preventDefault();
          if (colIndex >= currentRow.children.length - 1) {
            // Если мы в последней ячейке строки, переходим к следующей строке
            if (rowIndex < this.details.length - 1) {
              nextRow = rowIndex + 1;
              nextCol = 2; // Первая ячейка следующей строки
            } else {
              // Если это последняя строка, создаем новую
              this.addNewDetail();
              nextRow = this.details.length - 1;
              nextCol = 2;
              // Ждем обновления DOM перед поиском элемента
              this.$nextTick(() => {
                this.focusOnElement(nextRow, nextCol, currentRow, key);
              });
              return;
            }
          } else {
            nextCol = colIndex + 1;
          }
          break;

      }

      // Находим следующий элемент для фокуса
      this.focusOnElement(nextRow, nextCol, currentRow, e.key);
    },

    // Универсальный метод навигации по таблице
    handleNavigation(e) {
      // Обрабатываем пробел для переключения чекбоксов
      if (e.key === ' ') {
        e.preventDefault();
        const currentRow = e.target.closest('tr');
        if (!currentRow) return;

        const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
        if (rowIndex >= 0 && rowIndex < this.details.length) {
          // Определяем поле чекбокса по id
          const checkboxId = e.target.id;
          if (checkboxId.includes('Rotate_')) {
            this.details[rowIndex].rotate = this.details[rowIndex].rotate ? 0 : 1;
            this.detail.rotate = this.details[rowIndex].rotate;
          } else if (checkboxId.includes('ScreedBP_')) {
            this.details[rowIndex].screed_bp = this.details[rowIndex].screed_bp ? 0 : 1;
            this.detail.screed_bp = this.details[rowIndex].screed_bp;
          } else if (checkboxId.includes('CutToTxtrs_')) {
            this.details[rowIndex].cut_to_txtrs = this.details[rowIndex].cut_to_txtrs ? 0 : 1;
            this.detail.cut_to_txtrs = this.details[rowIndex].cut_to_txtrs;
          }
        }
        return;
      }

      // Обрабатываем стрелки для навигации по таблице
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
        this.handleTableNavigation(e);
        return;
      }

      // Обрабатываем Enter для перехода к следующему элементу (как стрелка вправо)
      if (e.key === 'Enter') {
        e.preventDefault();

        // Получаем текущую позицию в таблице
        const currentRow = e.target.closest('tr');
        if (!currentRow) return;

        const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
        const colIndex = Array.from(currentRow.children).indexOf(e.target.closest('td'));

        // Определяем следующую позицию (правая ячейка или следующая строка)
        let nextRow = rowIndex;
        let nextCol = colIndex + 1;

        // Если это последняя ячейка в строке, переходим к следующей строке
        if (nextCol >= currentRow.children.length || nextCol > (this.showEdgeSidesCount ? 6 : 4)) {
          if (rowIndex < this.details.length - 1) {
            nextRow = rowIndex + 1;
            nextCol = 2; // Первая редактируемая ячейка следующей строки
          } else {
            // Если это последняя строка, создаем новую
            this.addNewDetail();
            nextRow = this.details.length - 1;
            nextCol = 2;
            // Ждем обновления DOM перед поиском элемента
            this.$nextTick(() => {
              this.focusOnElement(nextRow, nextCol, currentRow, e.key);
            });
            return;
          }
        }

        // Находим следующий элемент для фокуса
        this.focusOnElement(nextRow, nextCol, currentRow, e.key);
        return;
      }

      // Для всех остальных клавиш (включая Tab) используем стандартное поведение
      return;
    },
    copyDetail() {
      let d = { ...this.detail };
      this.details.push(d);
    },
    removeDetail(i) {
      this.details.splice(i, 1);

      if (this.details.length === 0) {
        this.$store.commit('data/SET_DETAIL', {});
      } else {
        this.$store.commit('data/SET_DETAIL', this.details[this.details.length - 1]);
        setTimeout(() => {
          if (document.querySelector('[data-key="' + (this.details.length - 1) + '"] input:first-child')) {
            document.querySelector('[data-key="' + (this.details.length - 1) + '"] input:first-child').select()
          }
        }, 500);
      }
    },
    processDetailsNo() {
      this.details = this.details.map((detail, index) => {
        detail.No = index + 1;
        return detail;
      })
    },
    addNewDetail() {
      let cleanDeteil = {
        "No": this.details.length > 0 ? this.details[this.details.length - 1]['No'] + 1 : 1,
        "length": 20,
        "width": 20,
        "count": 1,
        "rotate": 0,
        "k1": 0,
        "k2": 0,
        "edge_t": null,
        "edge_b": null,
        "edge_l": null,
        "edge_r": null,
        "material": this.$store.getters['data/defaultMaterial'].ref || '',
        "note": '',
        "template": 1,
        "p1": 0,
        "p2": 0,
        "p3": 0,
        "p4": 0,
        "edge_template": null,
        "screed": 0,
        "screed_bp": 0,
        "cut_to_txtrs": 0,
        "name": '',
        "detail_name": '',
        "file": '',
      };
      this.details.push(cleanDeteil);

      this.visual((this.details.length - 1));

      setTimeout(() => {
        if (document.querySelector('[data-key="' + (this.details.length - 1) + '"] input:first-child')) {
          document.querySelector('[data-key="' + (this.details.length - 1) + '"] input:first-child').select()
        }
      }, 500);
    },
    pClear(i) {
      this.detail.p1 = 0;
      this.detail.p2 = 0;
      this.detail.p3 = 0;
      this.detail.p4 = 0;
      this.detail.edge_template = null;
      this.detail.note = '';
      this.detail.file = '';

      this.details[i].p1 = 0;
      this.details[i].p2 = 0;
      this.details[i].p3 = 0;
      this.details[i].p4 = 0;
      this.details[i].edge_template = null;
      this.details[i].note = '';
      this.details[i].file = '';
      this.$store.commit('data/SET_DETAIL', this.detail)
      this.$store.commit('data/SET_DETAILS', this.details)


      if (this.resp) {
        let itemKey = Object.keys(this.resp.Parts).find(key => this.resp.Parts[key].No == i + 1);
        if (itemKey) {
          if (this.resp.Parts[itemKey]['P1_'] != undefined) {
            this.resp.Parts[itemKey]['P1_'] = undefined;
          }
          if (this.resp.Parts[itemKey]['P2_'] != undefined) {
            this.resp.Parts[itemKey]['P2_'] = undefined;
          }
          if (this.resp.Parts[itemKey]['P3_'] != undefined) {
            this.resp.Parts[itemKey]['P3_'] = undefined;
          }
          if (this.resp.Parts[itemKey]['P4_'] != undefined) {
            this.resp.Parts[itemKey]['P4_'] = undefined;
          }
          if (this.resp.Parts[itemKey]['EdgeA1_'] != undefined) {
            this.resp.Parts[itemKey]['EdgeA1_'] = undefined;
          }
        }
      }

    },
    visual(i) {
      this.$store.commit('data/SET_DETAIL', this.details[i])
      app.detail = this.details[i];
      this.activeIndex = i;
    },
    checkbox(e, v) {
      // Работает только с Alt+цифра
      if (!e.altKey) return;

      // Получаем текущую строку
      const currentRow = e.target.closest('tr');
      if (!currentRow) return;

      const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
      if (rowIndex < 0 || rowIndex >= this.details.length) return;

      if (e.key == 0) {
        this.details[rowIndex][v] = 0;
        this.detail[v] = 0;
      } else if (e.key == 1) {
        this.details[rowIndex][v] = 1;
        this.detail[v] = 1;
      }
    },



    // Метод для поиска следующего доступного элемента ввода
    findNextAvailableInput(currentRow, startRow, startCol, direction) {
      const maxRows = this.details.length;
      const maxCols = currentRow.children.length;

      let currentRowIndex = startRow;
      let currentColIndex = startCol;
      let attempts = 0;
      const maxAttempts = maxRows * maxCols; // Максимальное количество попыток

      while (attempts < maxAttempts) {
        attempts++;

        // Определяем следующую позицию в зависимости от направления
        switch (direction) {
          case 'ArrowUp':
            if (currentRowIndex > 0) {
              currentRowIndex = currentRowIndex - 1;
            } else {
              // Если это первая строка, остаемся на месте
              currentRowIndex = 0;
            }
            break;
          case 'ArrowDown':
            if (currentRowIndex < maxRows - 1) {
              currentRowIndex = currentRowIndex + 1;
            } else {
              // Если это последняя строка, создаем новую
              this.addNewDetail();
              currentRowIndex = this.details.length - 1;
              // Ждем обновления DOM перед поиском элемента
              this.$nextTick(() => {
                this.focusOnElement(currentRowIndex, currentColIndex, currentRow, key);

              });
              return;
            }
            break;
          case 'ArrowLeft':
            if (currentColIndex > 0) {
              currentColIndex = currentColIndex - 1;
            } else {
              // Если это первая ячейка строки, переходим к предыдущей строке
              if (currentRowIndex > 0) {
                currentRowIndex = currentRowIndex - 1;
                currentColIndex = maxCols - 1;
              } else {
                // Если это первая строка, остаемся на месте
                currentColIndex = 0;
              }
            }
            break;
          case 'ArrowRight':
            if (currentColIndex < maxCols - 1) {
              currentColIndex = currentColIndex + 1;
            } else {
              // Если это последняя ячейка строки, переходим к следующей строке
              if (currentRowIndex < maxRows - 1) {
                currentRowIndex = currentRowIndex + 1;
                currentColIndex = 0;
              } else {
                // Если это последняя строка, создаем новую
                this.addNewDetail();
                currentRowIndex = this.details.length - 1;
                currentColIndex = 0;
                // Ждем обновления DOM перед поиском элемента
                this.$nextTick(() => {
                  this.focusOnElement(currentRowIndex, currentColIndex, currentRow, key);

                });
                return;
              }
            }
            break;
        }

        // Получаем элемент в указанной позиции
        const rowElement = currentRow.parentElement.children[currentRowIndex];
        if (!rowElement) continue;

        const cellElement = rowElement.children[currentColIndex];
        if (!cellElement) continue;

        // Проверяем, есть ли в ячейке интерактивные элементы
        const hasInteractiveElements = this.hasInteractiveElements(cellElement);

        if (hasInteractiveElements) {
          // Ищем элемент ввода в ячейке
          let inputElement = cellElement.querySelector('input:not([type="button"]):not([type="submit"]), select, textarea');

          if (inputElement && !inputElement.disabled && !inputElement.readOnly) {
            // Нашли доступный элемент, устанавливаем фокус
            if (inputElement.type === 'checkbox') {
              inputElement.focus();
            } else {
              inputElement.focus();
              if (typeof inputElement.select === 'function') {
                inputElement.select();
              }
            }

            // Обновляем активную строку для визуализации
            this.visual(currentRowIndex);
            return;
          }
        }
      }

      // Если не нашли доступный элемент, останавливаемся
      console.log('Не найдено доступных элементов для навигации');
    },

    // Метод для проверки наличия интерактивных элементов в ячейке
    hasInteractiveElements(cellElement) {
      // Проверяем наличие различных типов интерактивных элементов
      const hasInput = cellElement.querySelector('input:not([type="button"]):not([type="submit"])') !== null;
      const hasSelect = cellElement.querySelector('select') !== null;
      const hasTextarea = cellElement.querySelector('textarea') !== null;
      const hasCheckbox = cellElement.querySelector('input[type="checkbox"]') !== null;

      // Проверяем, что ячейка не содержит только текст или кнопки
      const hasOnlyText = cellElement.textContent.trim() !== '' &&
        !hasInput && !hasSelect && !hasTextarea && !hasCheckbox;
      const hasOnlyButtons = cellElement.querySelectorAll('button, input[type="button"], input[type="submit"]').length > 0 &&
        !hasInput && !hasSelect && !hasTextarea && !hasCheckbox;

      // Проверяем, что ячейка не пустая (без элементов и текста)
      const isEmpty = cellElement.textContent.trim() === '' &&
        !hasInput && !hasSelect && !hasTextarea && !hasCheckbox &&
        cellElement.querySelectorAll('button, input[type="button"], input[type="submit"]').length === 0;

      // Возвращаем true только если есть интерактивные элементы и нет только текста/кнопок/пустых ячеек
      return (hasInput || hasSelect || hasTextarea || hasCheckbox) && !hasOnlyText && !hasOnlyButtons && !isEmpty;
    },
    checkboxChange(val, v) {
      this.detail[v] = val ? 1 : 0;
    },
    onFileChanged($event, v) {
      const target = $event.target;
      if (target && target.files) {
        this.detail[v] = target.files[0];
      }
    },
    // Универсальный обработчик для селектов с поддержкой навигации и быстрого выбора
    handleSelectNavigation(e, data, field) {
      // Обработка стрелок и Enter для навигации
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(e.key)) {
        e.preventDefault();
        // Получаем текущую позицию в таблице
        const currentRow = e.target.closest('tr');
        if (!currentRow) return;

        const rowIndex = Array.from(currentRow.parentElement.children).indexOf(currentRow);
        const colIndex = Array.from(currentRow.children).indexOf(e.target.closest('td'));

        let nextRow = rowIndex;
        let nextCol = colIndex;

        // Определяем следующую позицию в зависимости от направления
        switch (e.key) {
          case 'ArrowUp':
            if (rowIndex > 0) {
              nextRow = rowIndex - 1;
            }
            break;
          case 'ArrowDown':
            if (rowIndex < this.details.length - 1) {
              nextRow = rowIndex + 1;
            } else {
              // Если это последняя строка, создаем новую
              this.addNewDetail();
              nextRow = this.details.length - 1;
              // Ждем обновления DOM перед поиском элемента
              this.$nextTick(() => {
                this.focusOnElement(nextRow, nextCol, currentRow, key);
              });
              return;
            }
            break;
          case 'ArrowLeft':
            if (colIndex > 0) {
              nextCol = colIndex - 1;
            } else {
              // Если это первая ячейка строки, переходим к предыдущей строке
              if (rowIndex > 0) {
                nextRow = rowIndex - 1;
                nextCol = currentRow.children.length - 1;
              }
            }
            break;
          case 'ArrowRight':
          case 'Enter':
            if (colIndex < currentRow.children.length - 1) {
              nextCol = colIndex + 1;
            } else {
              // Если это последняя ячейка строки, переходим к следующей строке
              if (rowIndex < this.details.length - 1) {
                nextRow = rowIndex + 1;
                nextCol = 2; // Первая редактируемая ячейка следующей строки
              } else {
                // Если это последняя строка, создаем новую
                this.addNewDetail();
                nextRow = this.details.length - 1;
                nextCol = 2;
                // Ждем обновления DOM перед поиском элемента
                this.$nextTick(() => {
                  this.focusOnElement(nextRow, nextCol, currentRow, e.key);
                });
                return;
              }
            }
            break;
        }

        // Находим следующий элемент для фокуса
        this.focusOnElement(nextRow, nextCol, currentRow, e.key);
        return;
      }

      // Обработка цифр для быстрого выбора (Alt+цифра или Ctrl+цифра)
      if (/^[0-9]$/.test(e.key) && (e.altKey || e.ctrlKey)) {
        e.preventDefault();
        let val = e.key;

        // Специальная обработка для template (числовые значения)
        if (field === 'template') {
          if (val >= '1' && val <= '9') {
            this.detail[field] = parseInt(val);
          }
          return;
        }

        // Обработка для остальных селектов
        if (val === '0' && field !== 'template') {
          this.detail[field] = null;
        } else if (+val - 1 >= 0 && data && data[val - 1]) {
          // Для detailsName используем name, для остальных - ref
          if (field === 'name' && data[val - 1].name) {
            this.detail[field] = data[val - 1].name;
          } else if (data[val - 1].ref !== undefined) {
            this.detail[field] = data[val - 1].ref;
          }
        }
        return;
      }

      // Для всех остальных клавиш используем стандартное поведение
      return;
    },

    // Метод для показа справки по горячим клавишам
    showHotkeysHelp() {
      this.$bvModal.show('hotkeys-modal');
    },

    // Метод для обновления материала с реактивностью
    updateMaterial(index, value) {
      this.$set(this.details[index], 'material', value);
      this.procesK(this.details[index]);
    },

    // Метод для получения стилей для выбранного материала
    getMaterialSelectStyle(materialRef) {
      const material = this.materials.find(m => m.ref === materialRef);
      if (material && material.color) {
        const contrastColor = this.getContrastColor(material.color);
        return {
          backgroundColor: material.color,
          color: contrastColor,
          borderColor: contrastColor,
        };
      }
      return {};
    },
    getEdgeSelectStyle(edgeRef) {
      const edge = this.edges.find(m => m.ref === edgeRef);
      if (edge && edge.color) {
        const contrastColor = this.getContrastColor(edge.color);
        return {
          backgroundColor: edge.color,
          color: contrastColor,
          borderColor: contrastColor,
        };
      }
      return {};
    },

    // Метод для получения контрастного цвета
    getContrastColor(hexColor) {
      if (!hexColor) return '#000000';

      // Убираем # если есть
      const hex = hexColor.replace('#', '');

      // Конвертируем в RGB
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Вычисляем яркость
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Возвращаем белый для темных цветов, черный для светлых
      return brightness > 128 ? '#000000' : '#ffffff';
    },

    // Метод для фокусировки на элементе
    focusOnElement(rowIndex, colIndex, currentRow, key) {
      const nextRowElement = currentRow.parentElement.children[rowIndex];
      if (nextRowElement) {
        const nextCell = nextRowElement.children[colIndex];

        if (nextCell) {
          // Ищем все возможные элементы ввода
          let nextInput = nextCell.querySelector('input, select, textarea');

          // Если не нашли, попробуем найти чекбокс отдельно
          if (!nextInput) {
            nextInput = nextCell.querySelector('input[type="checkbox"]');
          }

          // Если все еще не нашли, попробуем найти любой input
          if (!nextInput) {
            nextInput = nextCell.querySelector('input');
          }

          if (nextInput) {
            // Проверяем, не disabled ли элемент и не readonly
            if (nextInput.disabled || nextInput.readOnly) {
              // Если элемент недоступен, рекурсивно ищем следующий
              this.findNextAvailableInput(currentRow, rowIndex, colIndex, key);
              return;
            }

            // Для чекбоксов используем специальную логику фокуса
            if (nextInput.type === 'checkbox') {
              // Добавляем небольшую задержку для корректного фокуса на чекбоксе
              nextInput.focus();
            } else {
              nextInput.focus();
              if (typeof nextInput.select === 'function') {
                nextInput.select();
              }
            }

            // Обновляем активную строку для визуализации
            this.visual(rowIndex);
            // Автоматический скролл к элементу с учетом шапки
            this.scrollToElement(nextCell);
          } else {
            this.findNextAvailableInput(currentRow, rowIndex, colIndex, key);
          }
        }
      }
    },

    // Метод для автоматического скролла к элементу
    scrollToElement(element) {
      const tableWrapper = document.querySelector('.table-wrapper');
      if (!tableWrapper) return;

      const elementRect = element.getBoundingClientRect();
      const wrapperRect = tableWrapper.getBoundingClientRect();

      // Высота шапки таблицы
      const tableHeader = tableWrapper.querySelector('thead');
      const headerHeight = tableHeader ? tableHeader.offsetHeight : 0;

      // Проверяем видимость с учетом шапки
      const isVisible = (
        elementRect.top >= (wrapperRect.top + headerHeight) &&
        elementRect.bottom <= wrapperRect.bottom &&
        elementRect.left >= wrapperRect.left &&
        elementRect.right <= wrapperRect.right
      );

      if (!isVisible) {
        let scrollTop = tableWrapper.scrollTop;
        let scrollLeft = tableWrapper.scrollLeft;

        // Вертикально
        if (elementRect.top < (wrapperRect.top + headerHeight)) {
          scrollTop -= (wrapperRect.top + headerHeight - elementRect.top) + 10;
        } else if (elementRect.bottom > wrapperRect.bottom) {
          scrollTop += (elementRect.bottom - wrapperRect.bottom) + 10;
        }

        // Горизонтально
        if (elementRect.left < wrapperRect.left) {
          scrollLeft -= (wrapperRect.left - elementRect.left) + 10;
        } else if (elementRect.right > wrapperRect.right) {
          scrollLeft += (elementRect.right - wrapperRect.right) + 10;
        }

        tableWrapper.scrollTo({
          top: Math.max(0, scrollTop),
          left: Math.max(0, scrollLeft),
          behavior: 'smooth'
        });
      }
    }
  },
  mounted() {
    if (this.details.length && (!app.detail || !app.detail.No)) {
      app.detail = this.details[(this.details.length - 1)];
    }
    setTimeout(() => {
      if (document.querySelector('[data-key="' + (this.details.length - 1) + '"] input:first-child')) {
        document.querySelector('[data-key="' + (this.details.length - 1) + '"] input:first-child').select()
      }
    }, 300);

    document.addEventListener("wheel", function (event) {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });


    $(function () {

      $('[data-toggle="tooltip"]').each((i, el) => {
        $(el).tooltip({ boundary: "window" });
      });
    });

    this.$root.$on('update', i => {
      this.$forceUpdate();
    });

  },
  components: {
    DetailModal
  }
}
</script>
<style>
/* Modern Header Styles from Form.vue */
.table-section-v2 {
  background: #f8f9fa;
}

.table-card-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.table-section-v2 .table-content-v2 {
  background: white;
}

.table-header-v2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0;
}

.table-title-v2 {
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2c3e50;
  margin: 0;
}

.table-title-v2 i {
  color: #2c5aa0;
  font-size: 1.1rem;
}

/* Modern Button Styles from Form.vue - only for new buttons */
.table-section-v2 .btn-v2 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
}

.btn-compact {
  padding: 6px 10px !important;
  font-size: 0.75rem !important;
  font-weight: 500 !important;
  border-radius: 4px !important;
  display: flex;
  align-items: center;
  gap: 6px !important;
  justify-content: center !important;
  transition: all 0.3s ease;
}

.table-section-v2 .btn-outline-v2 {
  background: transparent;
  color: #2c5aa0;
  border: 1px solid #2c5aa0;
}

.table-section-v2 .btn-outline-v2:hover:not(:disabled) {
  background: #2c5aa0;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.table-section-v2 .btn-sm-v2 {
  padding: 6px 10px;
  font-size: 0.75rem;
}

.table-section-v2 .btn-v2:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.table-section-v2 .btn-v2:focus {
  outline: 1px solid #2c5aa0;
  outline-offset: 2px;
}

.table-section-v2 .btn-primary-v2 {
  background: #2c5aa0;
  color: white;
}

.table-section-v2 .btn-primary-v2:hover:not(:disabled) {
  background: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

/* Table Actions */
.table-actions-v2 {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

table input {
  border: none !important;
}

/* Стили для select с цветами материалов */
.custom-select.material {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
}

.custom-select.material:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.custom-select.material option {
  padding: 0.5rem;
  background-color: #fff;
  color: #212529;
  font-size: 16px;
  font-weight: 500;
}

.custom-select.material option:hover {
  background-color: #f8f9fa;
}

.custom-select.material option:selected {
  background-color: #0d6efd;
  color: #fff;
  font-weight: 600;
}

.main_table tbody {
  display: block;
  overflow-y: auto;
  padding-bottom: 25px;
}

.main_table thead {
  display: table;
  table-layout: fixed;
}

.table {
  font-size: 14px;
}

.edge_table .main_table td,
.main_table th {
  padding: .2rem !important;
}

.edge_table {
  font-size: 12px;
}

.table-wrapper {
  position: relative;
  overflow: auto;
  max-height: 500px;
  max-width: 100%;
}

.main_table {
  width: auto !important;
  min-width: 100%;
  padding-bottom: 5px !important;
  border-collapse: separate;
  border-spacing: 0;
}

.main_table thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
}

.main_table thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  border-bottom: 1px solid #dee2e6;
}

.main_table thead tr:first-child th {
  top: 0;
  border-bottom: 1px solid #dee2e6;
}

.main_table thead tr:nth-child(2) th {
  top: 50px;
  border-bottom: 1px solid #dee2e6;
}

.main_table tbody td {
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

/* Улучшенные стили для скролла */
.table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.main_table td,
.main_table th {
  padding: .15rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap;
}

.main_table td input:not([type='checkbox']) {
  width: 46px;
  border: none;
  padding: 6px 0 7px 3px;
  margin: -2px;
}

.main_table td .one {
  width: 55px !important;
  border: none;
}

.main_table td .one-qt {
  width: 28px !important;
  border: none;
}

.main_table td .sm-one {
  width: 15px !important;
  border: none;
}

.main_table td .two {
  width: 70px;
  border: none;
}

.main_table td .three {
  width: 100%;
  border: none;
}

.main_table input[name="note"] {
  width: 100px;
}

.main_table td select {
  width: 100px;
  border: none;
  font-size: 12px !important;
}

/* Стили для всех option элементов в таблице */
.main_table td select option {
  font-size: 16px;
  font-weight: 500;
  padding: 0.5rem;
}

.main_table td select option:selected {
  font-weight: 600;
}

.card-header {
  padding: .5rem .5rem !important;
}

.card h5 p {
  font-size: 11px !important;
  margin-bottom: 0px;
}

tr.active {
  background-color: #d2d2d2;
}

tr.active * {
  background-color: #d2d2d2;
}

.button-list {
  display: flex;
  gap: 10px;
  margin-top: 15px;
  padding: 10px 0;
  border-top: 1px solid #dee2e6;
  background-color: #fff;
}

/* Validation error styles */
.validation-error {
  position: relative;
  background-color: #fef2f2 !important;
  border-left: 3px solid #dc3545 !important;
}

.validation-error::before {
  content: "⚠";
  position: absolute;
  top: 2px;
  right: 2px;
  color: #dc3545;
  font-size: 12px;
  font-weight: bold;
  z-index: 5;
  background: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.validation-error input,
.validation-error select {
  border-color: #fecaca !important;
  background-color: #fef2f2 !important;
  color: #000 !important;
}

.validation-error:hover {
  background-color: #fee2e2 !important;
}

.validation-error:hover::before {
  background: #fee2e2;
}
</style>
